import React, { PureComponent } from 'react';
import entries from 'lodash/entries';
import TrackingContext from '../tracking/TrackingContext';

export default function withTrackingPropsProvider(
  WrappedComponent,
  propTransformObject,
) {
  class TrackingDataPropagater extends PureComponent {
    render() {
      return (
        // First, withTrackingPropsProvider will pull any existing tracking props from the TrackingContext that might already exist
        // This is done so that nested withTrackingPropsProviders can override parent props, or add other additional props to the tracking context as desired.  This is generally not done at the moment and should not be made a regular practice.
        <TrackingContext.Consumer>
          {additionalTrackingProps => {
            const { forwardedRef, ...rest } = this.props;
            // Add in props received from a parent withTrackingPropsProvider, followed by the contents of the object provided by the tracking prop.
            // This allows a child withTrackingPropsProvider to override values from a parent withTrackingPropsProvider
            const startingObj = {
              ...additionalTrackingProps,
              ...this.props.tracking,
            };
            // From here, we will take props on the tracked element and see if they're intended to be transformed into a tracking prop via the propsTransformObject.
            // Iterate through the propTransformObject...
            const combinedTrackingProps = entries(propTransformObject).reduce(
              (accum, curValue, curKey) => {
                let targetValue = rest[curValue[1]];
                // If a prop name exists on the tracked component that is identical to a value in propsTransform object..
                if (
                  typeof targetValue !== 'undefined' &&
                  typeof targetValue !== 'object'
                ) {
                  // Then copy the value of the prop on the tracked component into the tracking props.
                  // Its key will be the key matched to the found value inside the propsTransformObject
                  accum[curValue[0]] = targetValue;
                }
                return accum;
              },
              startingObj,
            );

            // Provide the children of the withTrackingPropsProvider with the combined tracking data
            return (
              <TrackingContext.Provider value={combinedTrackingProps}>
                <WrappedComponent ref={forwardedRef} {...this.props} />
              </TrackingContext.Provider>
            );
          }}
        </TrackingContext.Consumer>
      );
    }
  }

  return TrackingDataPropagater;
}

export function withTrackingPropsProviderRefForwarded(WrappedComponent) {
  let wrappedComponets = {};

  return React.forwardRef((props, ref) => {
    if (!wrappedComponets[WrappedComponent.displayName]) {
      wrappedComponets[
        WrappedComponent.displayName
      ] = withTrackingPropsProvider(WrappedComponent);
    }
    let RefForwarded = wrappedComponets[WrappedComponent.displayName];
    return <RefForwarded forwardedRef={ref} {...props} />;
  });
}
